type SortableRecord = {
  createdAt?: string;
  updatedAt?: string;
};

/** Stable list ordering: creation time, falling back to updatedAt for legacy rows. */
export function recordCreatedAt(record: SortableRecord): string {
  return record.createdAt || record.updatedAt || '';
}

export function sortByCreatedAsc<T extends SortableRecord>(items: T[]): T[] {
  return [...items].sort((a, b) =>
    recordCreatedAt(a).localeCompare(recordCreatedAt(b)),
  );
}

export function sortByCreatedDesc<T extends SortableRecord>(items: T[]): T[] {
  return [...items].sort((a, b) =>
    recordCreatedAt(b).localeCompare(recordCreatedAt(a)),
  );
}
